import { Button, Divider, MaxWidth } from '@advanza/ui'
import Page from 'components/ui/Page'
import { useAppSelector } from 'hooks/hooks'
import { useReclaimsList } from 'hooks/reclaimHooks'
import ReclaimsList from './ReclaimsList'

interface ReclaimsPageProps {
    filterId?: string
}

const ReclaimsPage = ({ filterId = 'all' }: ReclaimsPageProps) => {
    const { countries } = useAppSelector((state) => state.countries)
    const { filter } = useReclaimsList(filterId, { lastXMonths: 1, countries })

    const handleReclaims = () => {
        // Create URL with all filter parameters
        const params = new URLSearchParams()
        params.append('filterId', filterId)

        if (filter.lastXMonths) params.append('lastXMonths', filter.lastXMonths.toString())
        if (filter.serviceIds && filter.serviceIds.length > 0)
            params.append('serviceIds', filter.serviceIds.join(','))
        params.append('status', filter.status || 'open')
        if (filter.leadType) params.append('leadType', filter.leadType)
        if (filter.reasonIds && filter.reasonIds.length > 0)
            params.append('reasonIds', filter.reasonIds.join(','))
        if (filter.query) params.append('query', filter.query)
        params.append('hidePendingAi', 'true')

        const path = `/billing/reclaim-tasks?${params.toString()}`
        window.location.href = path
    }

    return (
        <Page title="Reclaims">
            <MaxWidth>
                <Divider m />
                <div className="flex flex-row items-center gap-4">
                    <h1>Reclaims</h1>
                    <Button onClick={handleReclaims}>Handle Reclaims</Button>
                </div>
                <Divider l />
                <ReclaimsList filterId={filterId} defaultOptions={{ lastXMonths: 1 }} />
            </MaxWidth>
        </Page>
    )
}

export default ReclaimsPage
